import { render, staticRenderFns } from "./thematicAreaReportAdvisor.vue?vue&type=template&id=7a0e65c4&scoped=true"
import script from "./thematicAreaReportAdvisor.vue?vue&type=script&lang=js"
export * from "./thematicAreaReportAdvisor.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaReportAdvisor.vue?vue&type=style&index=0&id=7a0e65c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e65c4",
  null
  
)

export default component.exports